export var attachScheme = function attachScheme(host) {
  return (host.startsWith('localhost') || host.startsWith('127.0.0.1') ? 'http://' : 'https://') + host;
};